// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EK-z","modalContent":"FK-z","header":"GK-z","close":"HK-z"};